/* Oppie header — minimal vanilla JS controller.
   - Toggles the mobile drawer (open / close via X button or backdrop click).
   - Closes drawer on Escape.
   - Locks body scroll while drawer is open.
   - Optionally adds .is-scrolled to .oppie-h-wrap after a few px of scroll
     so the pill background can shift (CSS handles the visual).
*/
(function () {
  const drawer = document.querySelector('[data-oppie-drawer]');
  const openTrigger = document.querySelector('[data-oppie-drawer-open]');

  if (drawer && openTrigger) {
    const open = () => {
      drawer.hidden = false;
      document.body.style.overflow = 'hidden';
      drawer.querySelector('[data-oppie-drawer-close]')?.focus?.();
    };
    const close = () => {
      drawer.hidden = true;
      document.body.style.overflow = '';
    };

    openTrigger.addEventListener('click', open);

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-oppie-drawer-close]')) {
        close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });
  }

  // Account-popup backdrop + outside-close — Shopify's <shopify-account>
  // opens its inner <dialog> with the `open` attribute (non-modal), so the
  // native ::backdrop pseudo never fires and clicking outside doesn't close
  // it. Mirror open-state to a body class so CSS can dim/blur the page, and
  // wire body-level click + Escape handlers to close on outside intent.
  const closeAccountDialog = () => {
    document.querySelectorAll('shopify-account').forEach(host => {
      const d = host.shadowRoot?.querySelector('dialog');
      if (d?.hasAttribute('open')) d.close();
    });
  };
  const syncAccountBackdrop = (host) => {
    const dialog = host?.shadowRoot?.querySelector('dialog');
    if (!dialog) return;
    const update = () => {
      document.body.classList.toggle('oppie-account-open', dialog.hasAttribute('open'));
    };
    new MutationObserver(update).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    update();
  };
  const syncAllAccountBackdrops = () => {
    if (!window.customElements?.whenDefined) return;
    customElements.whenDefined('shopify-account').then(() => {
      document.querySelectorAll('shopify-account').forEach((host) => {
        if (host.dataset.oppieBackdropSynced) return;
        host.dataset.oppieBackdropSynced = 'true';
        syncAccountBackdrop(host);
      });
    }).catch(() => {});
  };
  syncAllAccountBackdrops();
  // <shopify-account> is mounted from a <template> at >= 1024px (oppie-header.liquid);
  // when that happens after load (window resized past the breakpoint), sync again.
  document.addEventListener('oppie:account-mounted', syncAllAccountBackdrops);
  document.addEventListener('click', (e) => {
    if (!document.body.classList.contains('oppie-account-open')) return;
    if (e.target.closest('shopify-account')) return;
    closeAccountDialog();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.body.classList.contains('oppie-account-open')) {
      closeAccountDialog();
    }
  });

  // Scroll-shift flag (cheap rAF throttle)
  const wrap = document.querySelector('[data-oppie-header]');
  if (wrap) {
    let pending = false;
    const update = () => {
      pending = false;
      wrap.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', () => {
      if (!pending) {
        pending = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }
})();
